import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-slate-200 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 text-center">
        <h3 className="text-xl font-bold text-slate-900">PinMyDoc</h3>

        <p className="mt-3 text-sm text-slate-600 max-w-2xl mx-auto">
          Helping Ontario residents discover family doctors, walk-in clinics,
          pediatric care, and primary care providers.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-6 text-sm text-slate-500">
          <Link to="/doctors" className="hover:text-[#356DFF] transition">
            Find Care
          </Link>

          <Link to="/faq" className="hover:text-[#356DFF] transition">
            FAQ & Support
          </Link>

          <a
            href="mailto:support@techdroid.ca?subject=PinMyDoc%20Support"
            className="hover:text-[#356DFF] transition"
          >
            Contact Support
          </a>
        </div>

        <div className="mt-8 rounded-2xl border border-[#D7E7F6] bg-[#F5FAFF] p-5 max-w-3xl mx-auto">
          <p className="text-sm text-slate-700 leading-7">
            This platform does not provide medical advice, diagnosis, treatment,
            or emergency guidance. Provider information may change and must be
            confirmed directly with clinics and healthcare providers.
          </p>
        </div>

        <p className="mt-8 text-xs text-slate-400">
          © 2026 PinMyDoc. All rights reserved.
        </p>
      </div>
    </footer>
  );
}